<template>
  <div class="m-token-infos">
    <div class="head flex-left">
      <img :src="infos.icon" alt />
      <span>{{infos.symbol}}</span>
      <span v-if="infos.nickname">&nbsp;({{infos.nickname}})</span>
    </div>
    <div class="infos table-shadow">
      <div class="line flex-left">
        <img src="../../../assets/img/tip/red.png" />
        <label>发行总量</label>
        <span>{{(infos.total/100000000||'')|filterNum}}</span>
      </div>
      <div class="line flex-left">
        <img src="../../../assets/img/tip/blue.png" />
        <label>持有人</label>
        <span>{{infos.holders|filterNum}}</span>
      </div>
      <div class="line flex-left">
        <img src="../../../assets/img/tip/pink.png" />
        <label>交易次数</label>
        <span>{{infos.txCount|filterNum}}</span>
      </div>
      <div class="line flex-left">
        <img src="../../../assets/img/tip/green.png" />
        <label>发行时间</label>
        <span>{{infos.createdTime|formatTime}}</span>
      </div>
      <div class="line flex-left">
        <img src="../../../assets/img/tip/red.png" />
        <label>小数点</label>
        <span>8</span>
      </div>
      <div class="line flex-left">
        <img src="../../../assets/img/tip/blue.png" />
        <label>价值</label>
        <span>￥{{Number(infos.rmb).toFixed(2)||0.00}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    infos: {
      type: Object,
      default: () => {
        return {
          icon: "",
          symbol: "",
          total: "",
          holders: "",
          txCount: "",
          createTime: "",
          ceilpoint: "",
          web: ""
        };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.m-token-infos {
  .head {
    span {
      margin: 0 4px;
      font-size: 14px;
      color: $black;
    }
    .title {
      color: #9aaab9;
    }
    img {
      height: 23px;
    }
  }
  .infos {
    margin-top: 10px;
    background: $white;
    border: 1px solid rgba(235, 239, 241, 1);
    padding: 10px;
    color: $black;
    .line {
      line-height: 37px;
      label {
        margin-left: 10px;
        width: 6em;
      }
    }
  }
}
</style>